module.exports = __webpack_public_path__ + "static/media/end-tour.29c34022.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/alt-color/end-tour.svg
// module id = 1388
// module chunks = 0